import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'

import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import SensorSwitchyardChart from './SensorSwitchyardChart/SensorSwitchyardChart';
import SensorSwitchyardLog from './SensorSwitchyardLog/SensorSwitchyardLog';





export default function SensorSwitchyardTabs({TabTitle,ID}) {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));
   

    const [key, setKey] = useState('Chart');
    const location = useLocation();
    function handleClick(event) {
        event.preventDefault();
        // console.info('You clicked a breadcrumb.');
    }

    // console.log("TabtitleTabs", TabTitle, "ID", ID);

   

    return (
        <Box>
            
            <Box mt={spacing(1)}>
                <Tabs
                    style={{ justifyContent: "flex-start" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    
                    <Tab eventKey="Chart" title="Chart">
                    <SensorSwitchyardChart  TabTitle={TabTitle} ID={ID}/>
                    </Tab>

                
                    <Tab eventKey="Log" title="Log">
                    <SensorSwitchyardLog TabTitle={TabTitle} ID={ID}/>
                    </Tab>
                                 
                </Tabs>
            </Box>
        </Box>

    )
}